import type { ActionPhaseName } from "../policy/ActionPhaseName";

/**
 * Replay configuration controls "how" we replay:
 * - normal mode: await all animations
 * - fast mode: handlers may skip delays/visuals
 *
 * The engine will pass this into handlers.
 */
export interface ReplayConfiguration {
    /**
     * If true, handlers should skip time-consuming animations
     * and apply state immediately (useful for testing).
     */
    shouldSkipAnimations: boolean;
  
    /**
     * If true, unknown events/actions cause immediate failure.
     * Recommended for real-money correctness.
     */
    shouldFailOnUnknownTypes: boolean;

    actionPhaseSkipPolicy?: Partial<Record<ActionPhaseName, boolean>>;

  }
  
  export function createDefaultReplayConfiguration(): ReplayConfiguration {
    return {
      shouldSkipAnimations: false,
      shouldFailOnUnknownTypes: true,
      actionPhaseSkipPolicy: undefined,
    };
  }